module.exports = require('frontend-page');
